import { createContext } from "react"
export const LogsInitContext = createContext()

export const LogsInitProvider = ({ children }) => {
    const urlParams = new URLSearchParams(window.location.search)
    const debug = urlParams.get('debug') || false
    const page = urlParams.get('page') || false
    const contexto = urlParams.get('contexto') || false
    const componente = urlParams.get('componente') || false

    let arrNames = ['page', 'componente', 'contexto']
    let arrBool = [page, componente, contexto]

    const LogInit = (log, type) => {
        if (debug == 1) {
            if (arrNames.includes(type) && arrBool[arrNames.indexOf(type)]) {
                console.log(`${type} - ${log}`)
            }
        }
    }
    return (
        <LogsInitContext.Provider value={{ LogInit }}>
            <div>
                {children}
            </div>
        </LogsInitContext.Provider>
    )
}
